import { useEffect, useState } from "react";

export function useFetch<TData = any, TVariables = any>(
	model: TVariables,
	url: string,
	method: "POST" | "GET",
	triggers: string[]
) {
	const [result, setResult] = useState<TData>(null);
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<string>(null);
	useEffect(
		() => {
			const fetchData = async () => {
				setLoading(true);
				try {
					const response = await fetch(url, {
						method,
						headers: {
							Accept: "application/json",
							"Content-Type": "application/json",
						},
						body: JSON.stringify(model),
					});
					if (!response.ok) {
						setError(response.statusText);
					} else {
						const json = await response.json();
						setLoading(false);
						setResult(json);
						setError("");
					}
				} catch (error) {
					setError(`${error} Could not Fetch Data `);
					setLoading(false);
				}
			};
			fetchData();
		},
		[...triggers?.map((t) => model[t])]
	);
	return { result, loading, error };
}
